<template>
  <div class="page-content">
    <div class="content">
      <div class="search">
        <el-form :inline="true" :model="filters" :size="size" @keyup.enter.native="handleQuery" @submit.native.prevent>
          <el-form-item>
            <el-input style="width:160px" v-model="filters.workOrderId" placeholder="工单ID" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-select  style="width:160px"  v-model="filters.clientCompanyIdArray" filterable placeholder="客户" clearable>
              <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select  style="width:160px"  v-model="filters.baseIdArray" filterable placeholder="关联基地站" clearable>
              <el-option v-for="item in workBaseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select  style="width:120px"  v-model="filters.type" filterable multiple placeholder="类型" collapse-tags clearable>
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select  style="width:120px"  v-model="filters.statusArray" filterable multiple placeholder="状态" collapse-tags clearable>
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item>
            <el-select v-model="filters.timeType" style="width:140px" filterable placeholder="时间类型">
              <el-option label="按开始时间" :value="0"></el-option>
              <el-option label="按派单时间" :value="1"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-date-picker
              style="width:240px"
              v-model="filters.date"
              type="daterange"
              value-format="yyyy/MM/dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button :size="size" type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button :size="size" type="primary" @click="handleAdd">新建工单</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-content">
        <el-table :data="tableData" height="100%"
          header-cell-class-name='table-header-cell' cell-class-name='table-cell'
          border stripe fit  highlight-current-row
          >
          <el-table-column prop="workOrderId" label="工单ID" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="workOrderName" label="工单名称" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="planName" label="关联计划名称" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="workBaseName" label="基地站" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="clientCompanyName" label="客户" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="type" label="类型" min-width="100" :formatter="handleTypeFormat" show-overflow-tooltip></el-table-column>
          <el-table-column prop="orderCreatorName" label="派单人" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="time" label="派单时间" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              {{$moment(scope.row.createTime).format('YYYY/MM/DD HH:mm:ss')}}
            </template>
          </el-table-column>
          <el-table-column prop="mainExecutorName" label="现场负责人" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态" min-width="100" :formatter="handleStatusFormat" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column prop="createTime" label="创建时间" min-width="160" show-overflow-tooltip></el-table-column> -->
          <el-table-column fixed="right" label="操作" min-width="220" align="center">
            <template slot-scope="scope">
              <!-- 详情 -->
              <el-button @click.native.prevent="handleDetail(scope.$index, scope.row)" type="text" :size="size" >详情</el-button>
              <!-- 人员位置 -->
              <el-button v-if="scope.row.status >= 3 && scope.row.status <= 5" @click.native.prevent="handleLocationDetail(scope.$index, scope.row)" type="text" :size="size" >
                人员位置
              </el-button>
              <!-- 选派站点 -->
              <!-- <el-button v-if="scope.row.state === 9" @click.native.prevent="handleSelectStation(scope.$index, scope.row)" type="text" :size="size" >选派站点</el-button> -->
              <!-- 选派人员 -->
              <el-button v-if="scope.row.status === 1" @click.native.prevent="handleAppoint(scope.$index, scope.row)" type="text" :size="size" >选派人员</el-button>
              <!-- 退回 -->
              <el-button v-if="scope.row.status === 1" @click.native.prevent="handleSendBack(scope.$index, scope.row)" type="text" :size="size" >退回</el-button>
              <!-- 取消工单 -->
              <!-- <el-button v-if="scope.row.state === 9" @click.native.prevent="handleCancel(scope.$index, scope.row)" type="text" :size="size" >取消工单</el-button> -->
              <!-- 审核 -->
              <el-button v-if="scope.row.status === 10" @click.native.prevent="handleAudit(scope.$index, scope.row)" type="text" :size="size" >核对</el-button>
              <!-- 终止 -->
              <!-- <el-button @click.native.prevent="handleTermination(scope.$index, scope.row)" type="text" :size="size" >终止</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          background
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle"
          :current-page="currentPage"
          :page-sizes="[15, 30, 60, 100]"
          :page-size="limit"
          :page-count="pageCount"
          layout="sizes, prev, pager, next, jumper"
          >
        </el-pagination>
      </div>
    </div>
    <!-- 人员位置 -->
    <location-drawer ref="locationDrawer" v-if="locationDrawerVisible"></location-drawer>
    <order-dispatch-dialog ref="orderDispatchDialog" v-if="orderDispatchDialogVisible" dialogTitle='新建工单' :typeList='typeList' :isRedispatch='false' @handleQuery='handleQuery'></order-dispatch-dialog>
    <!-- 派单 -->
    <dispatch-dialog ref="dispatchDialog" v-if="dispatchDialogVisible" @handleQuery='handleQuery'></dispatch-dialog>
    <!-- 详情 -->
    <detail-drawer ref="detailDrawer" v-if="detailDrawerVisible" :planStatusList='planStatusList' :cycleList='cycleList' :statusList='statusList' :typeList='typeList'></detail-drawer>
    <!-- 选派站点 -->
    <select-station ref="selectStation" v-if="selectStationVisible" @handleQuery='handleQuery'></select-station>
    <!-- 审核 -->
    <audit-dialog ref="auditDialog" v-if="auditDialogVisible" @handleRejected='handleRejected' dialogTitle='核对' @handleQuery='handleQuery'></audit-dialog>
    <!-- 退回 -->
    <reject-dialog ref="rejectDialog" v-if="rejectDialogVisible" @handleQuery='handleQuery'></reject-dialog>
  </div>
</template>

<script>
import locationDrawer from './locationDrawer.vue'
import rejectDialog from './rejectDialog.vue'
import detailDrawer from './detailDrawer.vue'
import orderDispatchDialog from './orderDispatchDialog.vue'
import dispatchDialog from './dispatchDialog.vue'
import selectStation from './selectStation.vue'
import auditDialog from './auditDialog.vue'
export default {
  name: 'orderTask',
  components: {
    rejectDialog,
    orderDispatchDialog,
    dispatchDialog,
    detailDrawer,
    selectStation,
    auditDialog,
    locationDrawer
  },
  data () {
    return {
      locationDrawerVisible: false,
      sendBackDialogVisible: false,
      rejectDialogVisible: false,
      auditDialogVisible: false,
      selectStationVisible: false,
      detailDrawerVisible: false,
      dispatchDialogVisible: false,
      orderDispatchDialogVisible: false,
      workBaseList: [],
      typeList: [
        { label: "站点改造", value: 1 },
        { label: "抢修", value: 2 },
        { label: "试验", value: 3 },
        { label: "巡检", value: 4 },
        { label: "其他", value: 5 },
        { label: "带电检测", value: 6 },
        { label: "电能安装", value: 7 }
      ],
      statusList: [
        { label: '待分配', value: 9 },
        { label: '待接单', value: 1 },
        { label: '已接单', value: 2 },
        { label: '已出发', value: 3 },
        { label: '已到达', value: 4 },
        { label: '工作中', value: 5 },
        { label: '待核对', value: 10 },
        { label: '待审核', value: 6 },
        { label: '已完成', value: 7 },
        { label: '已取消', value: 8 },
      ],
      planStatusList: [
        { label: '计划中', value: 1 },
        { label: '已过期', value: 2 },
        { label: '已取消', value: 3 },
        { label: '执行中', value: 4 },
        { label: '已完成', value: 5 }
      ],
      cycleList: [
        { label: "无", value: 0 },
        { label: "周(1/4月)", value: 1 },
        { label: "月(1月)", value: 2 },
        { label: "季度(3月)", value: 3 },
        { label: "半年(6月)", value: 4 },
        { label: "年(12月)", value: 5 }
      ],
      size: 'small',
      filters: {
        timeType: 1,
        workOrderId: '',
        clientCompanyIdArray: [],
        type: [],
        statusArray: [],
        baseIdArray: [],
        date: []
      },
      tableData: [],
      currentPage: 1,
      limit: 15,
      pageCount: 1,
      companyList: []
    }
  },
  created () {
    let weekDay = this.$moment().format('E')
    this.filters.date = [
      this.$moment(new Date()).subtract(weekDay - 1, 'day').format('YYYY/MM/DD'),
      this.$moment(new Date()).add(7 - weekDay, 'day').format('YYYY/MM/DD')
    ]
    this.handleGetCompany()
    this.handleGetWorkBaseList()
    this.handleQuery()
  },
  methods: {
    handleTypeFormat (row, column, cellValue, index) {
      let val = ''
      this.typeList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
    handleStatusFormat (row, column, cellValue, index) {
      let val = ''
      this.statusList.forEach((item) => {
        if (item.value == cellValue) {
          val = item.label
        }
      })
      return val
    },
    handleGetWorkBaseList () {
      this.$api.electricOperations.listElectricOperationsWorkBases(0).then((res) => {
        if (res.success) {
          this.workBaseList = res.data
        }
      })
    },
    handleGetCompany () {
      this.$api.electricOperations.listClientsForElectricOperationsCompany(0, '', '').then((res) => {
        if (res.success) {
          this.companyList = res.data
        }
      })
    },
    handleQuery () {
      let startTime = this.filters.date[0] || ''
      let endTime = this.filters.date[1] || ''
      this.$api.electricOperations.listWorkOrderProfileForStationMaster({
        ...this.filters,
        startTime,
        endTime,
        currentPage: this.currentPage,
        pageSize: this.limit
        }).then((res) => {
        if (res.success) {
          this.tableData = res.data.listData
          this.currentPage = res.data.currentPage
          this.pageCount = res.data.totalPage
        }
      })
    },
    handleAdd () {
      this.orderDispatchDialogVisible = true
      this.$nextTick(() => {
        this.$refs.orderDispatchDialog.init(null)
      })
    },
    handleDispatch (index, row) {
    },
    handleSelectStation (index, row) {
      this.selectStationVisible = true
      this.$nextTick(() => {
        this.$refs.selectStation.init(row)
      })
    },
    handleAppoint (index, row) {
      this.dispatchDialogVisible = true
      this.$nextTick(() => {
        this.$refs.dispatchDialog.init(row)
      })
    },
    handleDetail (index, row) {
      this.detailDrawerVisible = true
      this.$nextTick(() => {
        this.$refs.detailDrawer.init(row)
      })
    },
    handleLocationDetail (index, row) {
      this.locationDrawerVisible = true
      this.$nextTick(() => {
        this.$refs.locationDrawer.init(row)
      })
    },
    handleAudit (index, row) {
      this.auditDialogVisible = true
      this.$nextTick(() => {
        this.$refs.auditDialog.init(row)
      })
    },
    handleRejected (index, row) {
      this.rejectDialogVisible = true
      this.$nextTick(() => {
        this.$refs.rejectDialog.init(row)
      })
    },
    handleSendBack (index, row) {
      console.log(index, row)
      this.rejectDialogVisible = true
      this.$nextTick(() => {
        this.$refs.rejectDialog.init(row)
      })
    },
    handleCancel (index, row) {
      console.log(index, row)
      this.rejectDialogVisible = true
      this.$nextTick(() => {
        this.$refs.rejectDialog.init(row, '取消工单')
      })
    },
    pageSizeChangeHandle (val) {
      console.log(val)
      this.limit = val
      this.handleQuery()
    },
    pageCurrentChangeHandle (val) {
      console.log(val)
      this.currentPage = val
      this.handleQuery()
    },
  }
}
</script>

<style lang="scss">
.table-content {
  height: calc(100% - 100px);
  .table-header-cell{
    background:rgba(220,225,230,1);
    color: #333;
    text-align: center;
  }
}
</style>
<style lang="scss" scoped>
.page-content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
  background-color: #fff;
  overflow: auto;
  .search {
    text-align: left;
  }
}

.pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
